import { outsourceInvoiceStatusConfig } from 'entities';

import { Card } from 'components/Blocks';

import { RegisterInvoice } from './Register';
import { UploadInvoice } from './UploadClientInvoice';
import { ConfirmPayment } from './ConfirmPayment';

import { InvoiceTabProps } from '../types';

export const statusToAction: Record<string, typeof RegisterInvoice> = {
  [outsourceInvoiceStatusConfig.waitingPayment.code]: ConfirmPayment,
  [outsourceInvoiceStatusConfig.pendingConfirmation.code]: RegisterInvoice,
  [outsourceInvoiceStatusConfig.registered.code]: UploadInvoice,
};

export function InvoiceAction({ invoice, ...props }: InvoiceTabProps): JSX.Element {
  const Action = statusToAction[invoice.status];

  return (
    Action && (
      <Card>
        <Action invoice={invoice} {...props} />
      </Card>
    )
  );
}
